import React, { useState } from 'react';

import { useDispatch, useSelector } from 'react-redux';

import { deleteTodo, editTodo, markCompleted } from '../../todo_redux/actions';



const Tasks = () => {
    let [editInput, setEditInput] = useState('');
    let [editId, setEditId] = useState('')
    let [statuses, setStatuses] = useState([])

    let dispacth = useDispatch()
    let todos = useSelector(
        (state) => state.todos
    )


    let handleEdit = (id, title) => {
        setEditId(id);
        setEditInput(title)
    }

    let changeHandler = (status) => {
        if (!statuses.includes(status)) {
            setStatuses([...statuses, status])
        }
        else {
            setStatuses(statuses.filter((item) => item !== status))
        }
    };

    let filterItems = todos.filter((todo) => {
        if (statuses.length === 0) {
            return true
        }
        else {
            return statuses.includes(todo.status)
        }
    })

    return (
        <div id='Tasks-section' className='w-75 p-4' style={{ margin: '20px auto', boxShadow: '6px 6px 10px black' }}>
            <div className="form-check form-check-inline">
                <input
                    className="form-check-input"
                    type="checkbox"
                    id="Active"
                    name='Active'
                    onChange={(event) => {
                        changeHandler(event.target.name)
                    }}
                />
                <label className="form-check-label" htmlFor="inlineCheckbox1" style={{ color: '#ffffff' }} >
                    Active
                </label>
            </div>
            <div className="form-check form-check-inline">
                <input
                    className="form-check-input"
                    type="checkbox"
                    id="Completed"
                    name='Completed'
                    onChange={(event) => {
                        changeHandler(event.target.name)
                    }} />
                <label className="form-check-label" htmlFor="inlineCheckbox2" style={{ color: '#ffffff' }}>
                    Completed
                </label>
            </div>

            {
                filterItems.length === 0 ? (
                    <center className='m-4'>
                        <h5 style={{ color: 'red', fontFamily : 'monospace' , }}>No Data here !</h5>
                    </center>
                ) : (
                    filterItems && filterItems.map((task) => {
                        return (
                            <div className="card" key={task.id} style={{ width: '100%', margin: '20px auto' }}>
                                <div className="card-header">Status : <span style={{ color: 'green' }}>{task.status}</span></div>
                                <div className="card-body">
                                    <div style={{ display: 'flex', justifyContent: 'space-between', cursor: 'pointer' }}>
                                        <p className="card-title">{task.title}</p>
                                        <button className='bg-white' data-bs-toggle="modal" data-bs-target="#exampleModal" style={{ border: 'none' }} onClick={() => {
                                            handleEdit(task.id, task.title)
                                        }}>
                                            <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" fill="currentColor" className="bi bi-pencil-square" viewBox="0 0 16 16">
                                                <path d="M15.502 1.94a.5.5 0 0 1 0 .706L14.459 3.69l-2-2L13.502.646a.5.5 0 0 1 .707 0l1.293 1.293zm-1.75 2.456-2-2L4.939 9.21a.5.5 0 0 0-.121.196l-.805 2.414a.25.25 0 0 0 .316.316l2.414-.805a.5.5 0 0 0 .196-.12l6.813-6.814z" />
                                                <path fillRule="evenodd" d="M1 13.5A1.5 1.5 0 0 0 2.5 15h11a1.5 1.5 0 0 0 1.5-1.5v-6a.5.5 0 0 0-1 0v6a.5.5 0 0 1-.5.5h-11a.5.5 0 0 1-.5-.5v-11a.5.5 0 0 1 .5-.5H9a.5.5 0 0 0 0-1H2.5A1.5 1.5 0 0 0 1 2.5z" />
                                            </svg>
                                        </button>
                                    </div>
                                    <div style={{ display: 'flex', justifyContent: 'flex-end', gap: '8px', flexWrap: 'wrap', marginTop: '20px' }}>
                                        <button type="button" className="btn btn-success" style={{ color: 'ffffff' }} onClick={(e) => {
                                            dispacth(markCompleted(task.id));
                                            e.target.disabled = true;
                                            
                                        }}>Mark as Completed</button>
                                        <button type="button" className="btn btn-outline-danger" style={{ color: 'ffffff' }} onClick={() => {
                                            if (window.confirm('Are you sure you want to delete this task permanently?')) {
                                                dispacth(deleteTodo(task.id));
                                            }
                                        }}>Delete</button>
                                    </div>
                                </div>
                            </div>

                        )
                })
                )
            }

            <div className="modal fade" id="exampleModal" aria-labelledby="exampleModalLabel" aria-hidden="true">
                <div className="modal-dialog">
                    <div className="modal-content">
                        <div className="modal-header">
                            <h5 className="modal-title" id="exampleModalLabel">Edit task</h5>
                            <button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
                        </div>
                        <div className="modal-body">
                            <form>
                                <div className="mb-3">
                                    <label htmlFor="message-text" className="col-form-label">Enter Task:</label>
                                    <input type='text' className="form-control" id="message-text" value={editInput} onChange={(e) => {
                                        setEditInput(e.target.value)
                                    }}></input>
                                </div>
                            </form>
                        </div>
                        <div className="modal-footer">
                            <button type="button" className="btn btn-secondary" data-bs-dismiss="modal">Close</button>
                            <button type="button" className="btn btn-primary" data-bs-dismiss="modal" onClick={() => {
                                dispacth(editTodo({ id: editId, title: editInput }))
                            }}>Save</button>
                        </div>
                    </div>
                </div>
            </div>
        </div>


    )
}

export default Tasks